module.exports = __webpack_public_path__ + "img/vip_bg.3ff4e838.png";